module.exports = __webpack_public_path__ + "static/media/secondary-logo.de3064d6.png";